import { useState, useEffect, useRef } from "react";

const BASE = "https://support.gs-group.fr/api";
const h = () => ({ "Content-Type":"application/json", Authorization:"Bearer "+localStorage.getItem("nexo_token") });

const TYPE_IC = { intervention:"🔧", sav:"🎫", stock:"📦", alerte:"🚨", info:"ℹ️", success:"✅" };

export default function NotifPanel({ T, onClose }) {
  const [notifs, setNotifs] = useState([]);
  const [loading, setLoading] = useState(true);
  const ref = useRef(null);

  useEffect(()=>{
    load();
    const fn = e => { if(ref.current && !ref.current.contains(e.target)) onClose(); };
    document.addEventListener("mousedown", fn);
    return ()=>document.removeEventListener("mousedown", fn);
  },[]);

  const load = async () => {
    setLoading(true);
    const d = await fetch(`${BASE}/notifications`,{headers:h()}).then(r=>r.json()).catch(()=>[]);
    setNotifs(Array.isArray(d)?d:[]);
    setLoading(false);
  };

  const markRead = async (id) => {
    await fetch(`${BASE}/notifications/${id}/lu`,{method:"PATCH",headers:h()});
    setNotifs(n=>n.map(x=>x.id===id?{...x,lu:true}:x));
  };

  const markAll = async () => {
    await fetch(`${BASE}/notifications/all/lu`,{method:"PATCH",headers:h()});
    setNotifs(n=>n.map(x=>({...x,lu:true})));
  };

  const del = async (id, e) => {
    e.stopPropagation();
    await fetch(`${BASE}/notifications/${id}`,{method:"DELETE",headers:h()});
    setNotifs(n=>n.filter(x=>x.id!==id));
  };

  const unread = notifs.filter(n=>!n.lu).length;

  return (
    <div ref={ref} style={{position:"absolute",top:48,right:0,width:360,background:T.card,border:`1px solid ${T.border}`,borderRadius:16,boxShadow:T.shadow,zIndex:500,overflow:"hidden",animation:"slideUp 0.2s ease"}}>
      
      {/* Header */}
      <div style={{padding:"14px 18px",borderBottom:`1px solid ${T.border}`,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
        <div style={{display:"flex",alignItems:"center",gap:10}}>
          <div style={{fontSize:15,fontWeight:800,color:T.text}}>Notifications</div>
          {unread>0&&<span style={{background:T.danger,color:"#fff",borderRadius:99,fontSize:10,fontWeight:800,padding:"2px 8px"}}>{unread}</span>}
        </div>
        {unread>0&&(
          <button onClick={markAll} style={{background:"none",border:"none",color:T.accent,fontSize:11,fontWeight:700,cursor:"pointer"}}>
            Tout lire
          </button>
        )}
      </div>

      {/* Liste */}
      <div style={{maxHeight:420,overflowY:"auto"}}>
        {loading ? (
          <div style={{textAlign:"center",padding:30,color:T.muted,fontSize:13}}>⏳ Chargement...</div>
        ) : notifs.length===0 ? (
          <div style={{textAlign:"center",padding:"40px 20px"}}>
            <div style={{fontSize:40,marginBottom:10}}>🔔</div>
            <div style={{fontSize:14,fontWeight:600,color:T.text,marginBottom:4}}>Aucune notification</div>
            <div style={{fontSize:12,color:T.muted}}>Tout est à jour !</div>
          </div>
        ) : notifs.map(n=>(
          <div key={n.id} onClick={()=>!n.lu&&markRead(n.id)}
            style={{display:"flex",gap:12,padding:"12px 18px",borderBottom:`1px solid ${T.border}20`,background:n.lu?"transparent":`${T.accent}08`,cursor:"pointer",transition:"background 0.15s"}}
            onMouseEnter={e=>e.currentTarget.style.background=T.accentDim}
            onMouseLeave={e=>e.currentTarget.style.background=n.lu?"transparent":`${T.accent}08`}>
            <div style={{width:36,height:36,borderRadius:11,background:T.accentDim,display:"flex",alignItems:"center",justifyContent:"center",fontSize:17,flexShrink:0}}>
              {TYPE_IC[n.type]||"🔔"}
            </div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:8}}>
                <div style={{fontSize:13,fontWeight:n.lu?500:700,color:T.text,lineHeight:1.3}}>{n.titre}</div>
                {!n.lu&&<div style={{width:7,height:7,borderRadius:"50%",background:T.accent,flexShrink:0,marginTop:4}}/>}
              </div>
              {n.message&&<div style={{fontSize:11,color:T.muted,marginTop:3,lineHeight:1.5}}>{n.message}</div>}
              <div style={{fontSize:10,color:T.muted,marginTop:5}}>
                {new Date(n.created_at).toLocaleDateString("fr-FR",{day:"numeric",month:"short",hour:"2-digit",minute:"2-digit"})}
              </div>
            </div>
            <button onClick={e=>del(n.id,e)}
              style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:16,opacity:0.5,flexShrink:0,padding:"0 2px"}}
              onMouseEnter={e=>e.currentTarget.style.opacity=1}
              onMouseLeave={e=>e.currentTarget.style.opacity=0.5}>
              ×
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
